<template>
  <div class="product-options row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.productFilters')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-lg-12 col-md-10 col-sm-12 "
            :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}"
            ref="optionsContainer">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <form class="clearfix ">
            <p class="text-danger" v-show="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="col-sm-12">
              <div class="pull-right" style="position:relative;z-index:2">
                <button type="submit" @click.prevent="validate" :title="$t('general.update')" class="btn btn-icon btn-success mar-bt-20 save">
                  <img src="/static/img/icons/save.png">
                  {{$t('general.update')}}
                </button>
              </div>
            </div>
            <table class="table width-table">
              <thead>
                  <tr>
                    <th width="1%"></th>
                    <th width="20%">{{$t('catalogProdOpt.type')}}</th>
                    <th v-if="showLocations" width="40%">{{$t('catalogProd.availableIn')}}</th>
                    <th width="25%">{{$t('catalogProdOpt.values')}} </th>
                    <th width="10%"></th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="(filter, key) in model">
                  <td><button class="btn btn-icon btn-danger" @click.prevent="deleteFilter(filter.id)" :title="$t('general.remove') + ' ' + $t('filter.filter')"><i class="ti-close"></i></button></td>
                  <td>
                    <input type="text"
                            :placeholder="$t('catalogProdOpt.name')"
                            class="form-control"
                            v-model="filter.type"
                            v-validate="modelValidate.required">
                  </td>
                  <td v-if="showLocations">
                    <template >
                      <v-select v-model="filter.location_ids"
                                  multiple
                                  :options="locations"
                                   value="id"
                                  label="name"
                                  :ref="'option' + filter.id"
                                  :placeholder="$t('general.all')"
                                  class=""
                                  :key="'option' + filter.id">
                      </v-select>
                    </template>
                  </td>
                  <td>
                    <template v-for="(val, key) in filter.filter_value">
                      <input type="text"
                              placeholder=""
                              class="form-control mid mar-bt-5"
                              v-model="val.value"
                              v-validate="modelValidate.required">
                      <button class="btn btn-simple btn-icon" @click.prevent="deleteValue(filter.id, val.id)"><i :title="$t('general.delete')" class="ti-close text-orange"></i></button>
                      <br/>
                    </template>
                    <button class="btn add" @click.prevent="addNewValue(filter.id)"><img src="/static/img/icons/add.png"> {{$t('general.add')}} {{$t('catalogProdOpt.value')}}</button>
                  </td>
                  <td>
                    <button class="btn btn-icon btn-info duplicate" @click.prevent="duplicateOption(filter.id)" :title="$t('general.duplicate') + ' ' + $t('filter.filter')"><img src="/static/img/icons/duplicate.png"></button>
                  </td>
                </tr>
                <tr >
                  <td colspan="5">
                    <button class="btn  add" @click.prevent="addNewOption()"><img src="/static/img/icons/add.png"> {{$t('general.add')}} {{$t('filter.filter')}}</button>
                  </td>
                </tr>
              </tbody>
            </table>

           <!-- <div class=" text-center pad-to-15 pad-bt-15">
              <button type="submit" class="btn btn-fill btn-success btn-wd" @click.prevent="validate">{{$t('general.update')}}</button>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      // GeneralTopBar,
      [Input.name]: Input
    },
    data () {
      return {
        model: [],
        modelValidate: {
          name: {required: true},
          required: {required: true}
        },
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 90,
        loading: true,
        showLocations: false,
        locations: []
      }
    },
    created () {
      this.$nextTick(function () {
        this.loading = true
      })
      var data = {
        token: this.$session.get('token'),
        detailed_options: 1
      }
      var self = this

      let companyData = this.$session.get('selectedCompanyData')
      this.locations = companyData.locations_details
      if (this.locations.length > 1) {
        this.showLocations = true
      }

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          self.defaultData = response.data[0]
        }
      })
      this.getData()
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      addNewValue (optId) {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }
        var self = this
        var filterId = optId
        // var optIdx = this.getObjectByElemKeyValue('id', optId, this.model)
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = {
              'id': null,
              'filter_id': filterId,
              'value': ''
            }
            newRow.id = response.data[0].id
            // var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options)
            // self.model.products_options[optIdx].values.push(newRow)

            let zElement = Object.values(self.model).filter(function (element) {
              return element.id === optId
            })
            if (Array.from(zElement[0].filter_value).length === 0) {
              zElement[0].filter_value = Array.from(Object.values(zElement[0].filter_value))
            }
            zElement[0].filter_value.push(newRow)
          }
        })
      },
      addNewOption () {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes',
          'counter': 2
        }
        var self = this
        this.apiRequest('/helpers', 'GET', data, function (response) {
          if (response.status === true) {
            let newRow = {
              'id': null,
              'type': '',
              'location_ids': [],
              'filter_value': []
            }
            newRow.id = response.data[0].id
            let newOption = {
              'id': null,
              'filter_id': response.data[0].id,
              'value': ''
            }
            newOption.id = response.data[1].id
            newRow.filter_value.push(newOption)
            if (!self.model) {
              self.model = []
            }
            self.model.push(newRow)
          }
        })
      },
      duplicateOption (optId) {
        var optIdx = this.getObjectByElemKeyValue('id', optId, this.model)
        const newObj = this.copyObject(this.model[optIdx])
        newObj.id = Math.floor((1 + Math.random()) * 0x10000)
        this.model.push(newObj)
      },
      deleteValue (optId, valId) {
        var optIdx = this.getObjectByElemKeyValue('id', optId, this.model)
        var valIdx = this.getObjectByElemKeyValue('id', valId, this.model[optIdx].filter_value)

        this.model[optIdx].filter_value.splice(valIdx, 1)
      },
      deleteFilter (filterId) {
        var self = this
        swal({
          text: self.$t('filter.areYouSureDelete'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              filter_id: filterId
            }
            this.apiRequest('/filter-remove', 'POST', data, function (response) {
              if (response.status) {
                swal({'text': self.$t('filter.deleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
                var optIdx = self.getObjectByElemKeyValue('id', filterId, self.model)
                self.model.splice(optIdx, 1)
              } else {
                console.warn(response)
                var msg = response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong')
                swal(
                  '',
                  msg,
                  'error'
                )
              }
            })
          }
        }).catch(() => {
         //
        })
      },
      saveDetails () {
        this.$nextTick(function () {
          this.loading = true
        })
        var companyID = this.$session.get('selectedCompany')

        let filters = this.copyObject(this.model)
        for (let idxO in filters) {
          let locIds = []
          if (filters[idxO].location_ids) {
            for (let idxL in filters[idxO].location_ids) {
              locIds.push(filters[idxO].location_ids[idxL]['id'])
            }
          }
          filters[idxO].location_ids = locIds
        }

        var data = {
          'token': this.$session.get('token'),
          'filters': filters,
          'company_id': companyID
        }

        var self = this
        this.apiRequest('filter', 'POST', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            self.model = response.data.filters
            self.$nextTick(function () { self.loading = false })
            if (response.data.message) {
              swal({'text': self.$t('filter.' + response.data.message), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            } else {
              swal({'text': self.$t('filter.filterUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          } else {
            self.$nextTick(function () {
              self.loading = false
              self.getData()
            })
            swal({'text': self.$t('filter.' + response.errors), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      getData () {
        var self = this
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/filter', 'GET', data, function (response) {
          if (response.status === true) {
            self.model = response.data
            self.$nextTick(function () {
              self.loading = false
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/ProductFilters.vue